import { motion } from 'framer-motion';
import { Cog } from 'lucide-react';

const Automations = () => {
  const services = [
    { 
      name: 'CRM & Sheets Automation', 
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
      features: ['Google Sheets Automation', 'Zoho CRM Automation', 'Lead Management', 'CRM Workflow Setup']
    },
    { 
      name: 'Payment & Communication', 
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
      features: ['Razorpay Payment Automation', 'WhatsApp Business Automation', 'Calendly Integration', 'Automated Notifications']
    },
    { 
      name: 'API & Integrations', 
      image: 'https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=800&q=80',
      features: ['API Integrations', 'Third-Party Connections', 'Webhook Setup', 'Custom Workflows']
    },
  ];

  return (
    <div className="min-h-screen pt-32 pb-20 px-4">
      <div className="max-w-6xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-16">
          <Cog className="w-16 h-16 mx-auto mb-6 text-neon-blue animate-spin-slow" />
          <h1 className="text-5xl font-bold mb-6 bg-gradient-to-r from-neon-purple to-neon-blue bg-clip-text text-transparent">
            Business Automation
          </h1>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            We streamline business operations through advanced workflow automation, reducing manual work and increasing efficiency.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 isolate">
          {services.map((service, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.2 }}
              className="glass-morphism rounded-2xl overflow-hidden hover:border-neon-purple/50 transition-all">
              <div className="h-48 overflow-hidden">
                <img src={service.image} alt={service.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-4 text-neon-purple">{service.name}</h3>
                <ul className="space-y-2">
                  {service.features.map((feature, j) => (
                    <li key={j} className="text-text-secondary flex items-start gap-2">
                      <span className="text-neon-blue mt-1">▹</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Automations;

